import { useState } from 'react'
import { ResponsiveTreeMap } from '@nivo/treemap'
import { Spinner, ErrorState, EmptyState } from '@/components/common/State'
import { useImpactTree, type RateView } from './useImpactTree'
import { RateToggle } from './RateToggle'

// $-at-risk by inventory — exec "where's the money" overview (design §5.8, CISO lens).
export function TreemapLens({ orgId }: { orgId: string }) {
  const [rate, setRate] = useState<RateView>('total')
  const { root, isLoading, error } = useImpactTree(orgId, rate)

  if (isLoading) return <Spinner />
  if (error) return <ErrorState error={error} />
  const children = root?.children ?? []
  if (children.length === 0)
    return (
      <EmptyState
        icon="dashboard"
        title="No $-at-risk data"
        hint="Author inventory economics to populate the treemap."
      />
    )

  // Top-level tiles = inventories (one level; conservation drill-down is the sunburst).
  const data = {
    name: 'org',
    children: children.map((c) => ({ name: c.name, loc: c.total_at_risk })),
  }

  return (
    <div>
      <RateToggle rate={rate} onChange={setRate} />
      <div className="h-[520px]">
        <ResponsiveTreeMap
          data={data}
          identity="name"
          value="loc"
          valueFormat=".02s"
          label={(n) => `${n.id}`}
          labelSkipSize={18}
          parentLabelPosition="left"
          colors={{ scheme: 'blues' }}
          borderColor={{ from: 'color', modifiers: [['darker', 0.3]] }}
          nodeOpacity={0.85}
        />
      </div>
    </div>
  )
}
